import React, { FC } from 'react';
import { useResizeContext } from "../../../../providers/ResizeProvider/ResizeProvider";
import { Section } from "../../../../components/Section";
import { FlexBox } from "../../../../../../components/FlexBox";
import { Title } from "../../../../components/Topography/Title";
import { homePageTexts } from "../../const";
import { Paragraph } from "../../../../components/Topography/Paragraph";
import { PopupScreenshot } from "../../components/PopupScreenshot";

export const CaptureScreenshotSection: FC = () => {
    const { isMobile } = useResizeContext();

    return (
        <Section style={{marginTop: 0}}>
            <FlexBox
                justify='space-between'
                align={isMobile ? 'middle' : 'top'}
                style={{ gap: isMobile ? '0' : '80px', flexDirection: isMobile ? 'column-reverse' : 'row' }}
            >
                <PopupScreenshot/>
                <FlexBox column style={{ padding: isMobile ? 0 : '40px', gap: '40px' }}>
                    <FlexBox column gap='medium'>
                        <Title level={3} size={isMobile ? 'tiny' : 'small'} weight='regular' style={{ textTransform: 'uppercase' }} secondary>
                            {homePageTexts.captureScreenshotWithJustOneClick.h3}
                        </Title>
                        <Title level={2} size={isMobile ? 'normal' : 'big'} weight='bold' >
                            {homePageTexts.captureScreenshotWithJustOneClick.h2}
                        </Title>
                    </FlexBox>
                    <Paragraph  size='small' weight='regular'>
                        {homePageTexts.captureScreenshotWithJustOneClick.p}
                    </Paragraph>
                </FlexBox>
            </FlexBox>
        </Section>
    );
}